var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'd-flex h-100 flex-column gmb-control-column',
    { 'gmb-control-column--no-max-width': _vm.noMaxWidth },
  ]},[_c('div',{staticClass:"d-flex flex-grow-1 h-0 flex-column"},[_vm._t("default")],2),(_vm.hasControls)?_c('div',{staticClass:"d-flex border-top pt-3 flex-column gmb-control-column__controls"},[_c('div',{staticClass:"d-flex mx-0 container-xl px-0 flex-row"},[_vm._t("controls")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }